import React, {useEffect, useState} from 'react';
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import {Button, Modal} from 'antd';
import {useHistory} from "react-router-dom";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";

const Users = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [users, setUsers] = useState([])
    const [selectUser, setSelectUser] = useState("")
    const [usersObjSize, setUsersObjSize] = useState(1)
    const [current, setCurrent] = useState(1);
    const [usersObj, setUsersObj] = useState({
        page: 1
    })

    const getUsers = (size) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/administrator/all" + (size ? "?page=" + size : "") , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setUsers(res.data?.items)
                setUsersObj(res.data)

            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const changePagination = (current, size) => {
        setUsersObjSize(size)
        getUsers(size)
    }
    let history = useHistory()
    const createPage = () => {
        history.push("/main/hr-admin/users/add-user")
    }
    const editPage = (e) => {
        history.push("/main/hr-admin/users/edit/" + e)
    }
    const showModalDelete = (e) => {
        setIsModalOpen(true);
        setSelectUser(e)
    };
    const showModalBlock = () => {
        setIsModalOpen2(true);
    };
    const handleOkDelete = () => {
        setIsModalOpen(false);
        axios.delete(API_PATH + "company/" + localStorage.getItem('id') + "/administrator/delete/" + selectUser, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                toast.success("Удалено")
                    getUsers()

            }
            )
    };
    const handleCancelDelete = () => {
        setIsModalOpen(false);
    };
    const handleOkBlock = () => {
        setIsModalOpen2(false);
    };
    const handleCancelBlock = () => {
        setIsModalOpen2(false);
    };

  useEffect(() =>{
      getUsers()
  }, [])

    return (
        <div className="users">
            <div className="employees-header">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="left-head">
                        <h6 className="font-family-medium">Пользователи</h6>
                    </div>
                    <div className="right-head">
                        {/*<button className="upload-btn font-family-medium ml-16 mr-16"><img*/}
                        {/*    src="/icon/upload.svg"/> Экспорт в Excel*/}
                        {/*</button>*/}
                        <button className="add-btn font-family-medium" onClick={createPage}><img src="/icon/plus.svg"/> Добавить новое
                        </button>
                    </div>
                </div>
            </div>
            <div className="emp-table">
                <TableContainer component={Paper}>
                    <Table sx={{minWidth: 650}} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className="table-head">Имя</TableCell>
                                <TableCell className="table-head" align="right">Username</TableCell>
                                <TableCell className="table-head" align="right">Роль</TableCell>
                                <TableCell className="table-head" align="right">Последняя сессия</TableCell>
                                <TableCell className="table-head" align="right">Действие</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.map((item) => (
                                <TableRow
                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                >
                                    <TableCell component="th" scope="row">
                                        <span className="t-name font-family-medium">{item?.first_name + " " + item?.last_name}</span>
                                    </TableCell>
                                    <TableCell className="twt" align="right"><span
                                        className="t-name font-family-medium">{item?.username}</span></TableCell>
                                    <TableCell className="twt" align="right"><span
                                        className="t-name font-family-medium">{item?.role?.name}</span></TableCell>
                                    <TableCell className="twt" align="right"><span className="font-family-medium">18:45, 11,12.2023</span></TableCell>
                                    <TableCell className="twt" align="right">
                                        <div className="con-btns-all">
                                            <button className="t-delete-btn font-family-medium"
                                                    onClick={() => showModalDelete(item?.id)}>Удалить
                                            </button>
                                            <button className="t-edit-btn font-family-medium" onClick={() => editPage(item?.id)}>Изменить</button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>
            <Modal title="Внимание!"
                   open={isModalOpen}
                   onCancel={handleCancelDelete}
                   footer={[
                       <Button key="submit" type="default" onClick={handleCancelDelete}>
                           Отменить
                       </Button>,
                       <Button key="submit" type="danger"  className="my-red-canc"  onClick={handleOkDelete}>
                           Да, удалить
                       </Button>
                   ]}
            >
                <p className="pt-2 pb-2 text-white">Вы уверены, что удалите этого пользователя? Это невозможно отменить</p>
            </Modal>
            <Modal title="Внимание!"
                   open={isModalOpen2}
                   onCancel={handleCancelBlock}
                   footer={[
                       <Button key="submit" type="default"   onClick={handleCancelBlock}>
                           Отменить
                       </Button>,
                       <Button key="submit" type="primary"   onClick={handleOkBlock}>
                           Да, подтверждаю
                       </Button>
                   ]}
            >
               <p className="pt-2 pb-2 text-white">Вы уверены, что заблокируете этого пользователя?</p>
            </Modal>
            <div className="pag-bottom">
                <Stack spacing={2}>
                    <Pagination count={usersObj?.pages} total={usersObj?.total} current={current}
                                onChange={changePagination} shape="rounded"/>
                </Stack>
            </div>
        </div>
    );
};

export default Users;